import { fetchCasinos } from './utils'
;(async () => {
  const dropDownOptions = async (options) => {
    const casinos = await fetchCasinos()
    casinos.items.forEach((casino) => {
      const button = document.createElement('button')
      button.classList.add(
        'spinoko-casino-dropdown--option',
        'appearance-none',
        'block',
        'w-full',
        'text-left',
        'sp-mb-2',
        'sp-px-4',
        'cursor-pointer',
      )
      button.dataset.value = casino.link
      button.innerText = casino.casino_fields.name
      options.appendChild(button)
    })
  }

  const dropDownLoadEvent = (block, options) => {
    block.addEventListener('mouseover', async (e) => {
      if (!block.dataset.loaded) {
        block.dataset.loaded = true
        await dropDownOptions(options)
        block.querySelector('.spinoko-casino-dropdown--loading').classList.add('hidden')
      }
    })
  }

  const adjustTriggerButton = (button) => {
    if (!button.style.borderBottomRightRadius) {
      button.style.borderBottomRightRadius = 0
      button.style.borderBottomLeftRadius = 0
    } else {
      button.style.removeProperty('border-bottom-right-radius')
      button.style.removeProperty('border-bottom-left-radius')
    }
    button.querySelectorAll('.icon').forEach((i) => i.classList.toggle('hidden'))
  }

  const dropDownClickEvents = (block, options) => {
    block.addEventListener('click', (e) => {
      if (
        e.target.classList.contains('spinoko-casino-dropdown--trigger') ||
        e.target.closest('.spinoko-casino-dropdown--trigger')
      ) {
        adjustTriggerButton(e.target)
        options.classList.toggle('hidden')
      }

      if (
        e.target.classList.contains('spinoko-casino-dropdown--button') ||
        e.target.closest('.spinoko-casino-dropdown--button')
      ) {
        if (block.dataset.link) {
          window.location = block.dataset.link
        } else {
          const trigger = block.querySelector('.spinoko-casino-dropdown--trigger')
          trigger.classList.add('transform', 'scale-[1.02]')
          setTimeout(() => trigger.classList.remove('transform', 'scale-[1.02]'), 500)
        }
      }

      if (
        e.target.classList.contains('spinoko-casino-dropdown--option') ||
        e.target.closest('.spinoko-casino-dropdown--option')
      ) {
        block.querySelector('.spinoko-casino-dropdown--selected').innerText = e.target.innerText
        block.dataset.link = e.target.dataset.value
        adjustTriggerButton(block.querySelector('.spinoko-casino-dropdown--trigger'))
        options.classList.add('hidden')
      }
    })
  }

  const dropDownSearchEvent = (block, options) => {
    block.querySelector('input[type=search]').addEventListener('keyup', (e) => {
      if (e.key === 'Escape') {
        if (e.target.value === '') {
          options.classList.add('hidden')
          adjustTriggerButton(block.querySelector('.spinoko-casino-dropdown--trigger'))
        } else {
          e.target.value = ''
        }
      }

      const buttons = options.querySelectorAll('button[data-value]')

      buttons.forEach((button) => {
        if (button.innerText.toLowerCase().includes(e.target.value.toLowerCase())) {
          button.classList.remove('hidden')
          button.classList.add('block')
        } else {
          button.classList.add('hidden')
          button.classList.remove('block')
        }
      })

      if (!Array.from(buttons).filter((op) => !op.classList.contains('hidden')).length) {
        block.querySelector('.spinoko-casino-dropdown--404').classList.remove('hidden')
      } else {
        block.querySelector('.spinoko-casino-dropdown--404').classList.add('hidden')
      }
    })
  }

  const dropDownBlocks = document.querySelectorAll('.spinoko-casino-dropdown-block')
  dropDownBlocks.forEach((block) => {
    const options = block.querySelector('.spinoko-casino-dropdown--options')

    dropDownClickEvents(block, options)
    dropDownSearchEvent(block, options)
    dropDownLoadEvent(block, options)
  })
})()
